<script setup lang="ts">
    import { toRefs } from "vue";
    import IconLabel from "@/components/IconLabel.vue";
    import CardListItem from "@/components/CardListItem.vue";
    import { PatientoversiktItemDisplay } from "@/tabs/Patientoversikt/types";

    const props = defineProps<{
        item: PatientoversiktItemDisplay;
    }>();

    const { item } = toRefs(props);

    const emit = defineEmits(["openItem"]);

    const openItem = () => {
        emit("openItem", item.value);
    };
</script>

<template>
    <CardListItem class="patientoversikt-card-list-item">
        <template #section-header-left>
            <h5 @click="openItem">{{ item.title }}</h5>
        </template>
        <template #section-header-right>
            <span>{{ item.due_date ?? item.created_at }}</span>
        </template>
        <template #section-body>
            <span>{{ item.info }}</span>
        </template>
        <template #section-footer-left>
            <IconLabel v-if="item.status" :icon="item.statusIcon" :text="item.status" size="small" />
        </template>
        <template #section-footer-right>
            <span>{{ item.accountableName }}</span>
        </template>
    </CardListItem>
</template>

<style lang="scss" scoped>
    .patientoversikt-card-list-item {
        h5:hover {
            cursor: pointer;
        }
    }
</style>
